export const faq = {
  seo: {
    title: 'Questions fréquentes sur Bistroo | Bistroo',
    description: "Réponses aux questions les plus fréquentes sur Bistroo : tarifs, intégration, matériel, paiements et plus encore.",
  },
  hero: {
    heading: {
      1: 'Les',
      2: 'questions les plus fréquentes',
      3: 'sur une page claire',
    },
    description: {
      1: 'Vous avez une question ? Il y a de fortes chances que vous trouviez la réponse ci-dessous. Nous avons rassemblé les questions les plus fréquemment posées pour vous, afin que vous puissiez avancer rapidement et facilement par vous-même.',
      2: 'Vous ne trouvez toujours pas ? Notre service client est bien sûr là pour vous.',
    },
  },
  questions: {
    1: {
      question: 'Qu\'est-ce que Bistroo et comment ça fonctionne ?',
      answer:
        'Bistroo est une entreprise de logiciels innovante qui se concentre sur la numérisation de la restauration. L\'entreprise propose des outils faciles à utiliser qui permettent aux restaurants, cafés et autres établissements de restauration d\'améliorer leur présence en ligne et de la gérer de manière autonome.',
      bullet_title: 'Bistroo fournit notamment :',
      bullets: {
        1: 'Des sites web et des boutiques en ligne pour les établissements de restauration, entièrement personnalisables selon vos souhaits.',
        2: 'Des modules QR permettant aux clients de commander et payer facilement via leur mobile sur place.',
        3: 'Un système de gestion dans lequel vous pouvez tout configurer vous-même : menus, horaires d\'ouverture, promotions, paramètres de livraison et plus encore.',
      },
      how: 'Comment ça fonctionne ?',
      list: {
        1: 'Vous créez un compte chez Bistroo et configurez votre environnement numérique. Vous pouvez ajouter votre carte de menu, modifier les paramètres, connecter le mode de paiement et décider vous-même à quoi ressemble votre restaurant en ligne.',
        2: 'Une fois que tout est prêt, votre site web, votre boutique en ligne ou votre module QR est mis en ligne. Les clients peuvent vous trouver, passer des commandes ou commander sur place via QR.',
        3: 'Vous gardez le contrôle total sur votre boutique. Tout est configurable par vous-même, mais si vous avez besoin d\'aide, l\'équipe de support de Bistroo est là pour vous soutenir de manière optimale.',
      },
    },
    2: {
      question: 'Bistroo est-il gratuit ?',
      answer:
        'Oui, Bistroo propose un forfait d\'entrée gratuit. Cela signifie qu\'en tant que restaurateur, vous pouvez utiliser les modules gratuitement, sans frais d\'abonnement mensuels ni frais de démarrage.',
      how: 'Comment fonctionne le forfait gratuit ?',
      bullets: {
        1: 'Démarrage gratuit : Vous pouvez commencer immédiatement à configurer votre boutique en ligne et votre site web, sans frais de démarrage ! Seulement pour le module QR, nous facturons le prix coûtant des autocollants.',
        2: 'Pas de frais d\'abonnement : nous ne facturons pas de frais d\'abonnement fixes, nous demandons seulement un pourcentage de frais de volume pour une commande réussie.',
        3: 'Configurable par vous-même : Vous avez accès à toutes les fonctionnalités de base pour configurer entièrement votre environnement numérique selon vos souhaits.',
        4: 'Support disponible : Même en tant qu\'utilisateur gratuit, vous pouvez compter sur le soutien de notre équipe de support.',
        5: 'Changement facile : vous pouvez changer de formule chaque mois.',
      },
      why: 'Pourquoi ce modèle ?',
      why_answer:
        'Bistroo veut donner aux restaurateurs la liberté de commencer à se numériser sans obstacles financiers. Ce n\'est que lorsque vous obtenez réellement des résultats que vous payez un pourcentage de frais de volume. Cela en fait une solution accessible et équitable pour les établissements de restauration aussi bien débutants qu\'établis.',
    },
    3: {
      question: 'Puis-je d\'abord essayer Bistroo ?',
      answer:
        'Oui, certainement ! Toutes les formules de Bistroo sont disponibles en essai gratuit de 30 jours. Cela signifie que vous pouvez utiliser toutes les fonctionnalités de la formule adaptée à votre établissement sans engagement, que vous choisissiez un site web, une boutique en ligne ou un module de commande QR.',
      what: 'Que comprend la période d\'essai ?',
      bullets: {
        1: '30 jours d\'accès gratuit à toutes les fonctionnalités de la formule choisie.',
        2: 'Liberté totale pour configurer et tester votre environnement numérique.',
        3: 'Soutien de l\'équipe de support pendant toute la période d\'essai.',
        4: 'Matériel en prêt (le cas échéant) pendant la période d\'essai.',
      },
    },
    4: {
      question: 'Comment gérez-vous les demandes supplémentaires ?',
      answer: {
        1: 'Chez Bistroo, nous prenons les demandes supplémentaires au sérieux. Notre équipe de support traite quotidiennement toutes les demandes entrantes, afin que vous soyez aidé rapidement et que votre environnement en ligne reste toujours à jour.',
        2: 'De plus, nous organisons chaque semaine une réunion au cours de laquelle nous discutons de tous les retours et demandes reçus. Lors de cette réunion, nous évaluons quelles suggestions peuvent être intégrées dans les futures mises à jour de fonctionnalités.',
      },
    },
    5: {
      question: 'Comment fonctionnent les versements chez Bistroo ?',
      answer: {
        1: 'Chez Bistroo, les versements sont simples, flexibles et entièrement automatisés.',
        2: 'En résumé : Vous gardez le contrôle sur vos flux financiers, et nous assurons un processus fluide et transparent. Aussi simple que ça.',
      },
      bullets: {
        1: 'Connectez votre fournisseur de paiement à notre système.',
        2: 'Choisissez vous-même le moment du versement : vous choisissez si vous souhaitez être payé quotidiennement, hebdomadairement ou mensuellement, exactement comme cela convient à votre entreprise.',
        3: 'Facturation automatique : Pour chaque versement, une facture est automatiquement générée, afin que votre comptabilité soit toujours correcte et à jour.',
      },
    },
    6: {
      question: 'Pourquoi vous choisir ? Qu\'est-ce qui vous différencie ?',
      answer: {
        1: 'Avec Bistroo, vous redevenez pleinement entrepreneur. Notre solution vous donne, en tant que vendeur, le contrôle sur votre boutique en ligne. Vous devenez véritablement propriétaire du processus, avec un contrôle total sur votre restaurant en ligne. Nous offrons tous les outils et le soutien dont vous avez besoin pour réussir votre restaurant en ligne.',
        2: 'Dans le Manager, notre tableau de bord back-office facile à utiliser, vous gérez facilement tout en temps réel : des menus, prix, remises et promotions aux (rem)boursements et données clients. Tout est clair et intuitif, afin que vous puissiez vous concentrer sur ce qui compte vraiment.',
        3: 'Bistroo propose également une tarification unique : vous choisissez la structure de coûts qui convient à votre entreprise. Pas de surprises, pas de petits caractères.',
        4: 'Bistroo vous donne la liberté d\'entreprendre en ligne à votre façon.',
      },
      bullets: {
        1: '30 jours d\'essai gratuit',
        2: 'Résiliable mensuellement',
        3: 'Pas de contrats cachés, simplement clair et transparent',
      },
    },
    7: {
      question: 'Comment fonctionne l\'administration ?',
      answer: {
        1: 'Chez Bistroo, l\'administration est organisée de la manière la plus simple possible. Pour chaque versement, vous recevez automatiquement une facture de chiffre d\'affaires claire avec tous les détails nécessaires. Vous pouvez ainsi l\'enregistrer directement sans tracas.',
        2: 'En résumé : votre administration est toujours complète, claire et prête pour votre comptabilité sans actions manuelles supplémentaires.',
      },
    },
    8: {
      question: 'Combien de temps dure l\'intégration ?',
      answer:
        'Chez Bistroo, vous êtes rapidement en ligne : dans les 48 heures, votre restaurant en ligne est entièrement configuré et prêt à l\'emploi. Vous pouvez ainsi commencer à commander et à vendre presque immédiatement !',
    },
    9: {
      question: 'Quels modes de paiement prenez-vous en charge ?',
      answer:
        'Bistroo collabore avec les principaux fournisseurs de paiement Stripe et Mollie. Via ces partenaires, nous prenons en charge presque tous les modes de paiement courants (et moins courants), aussi bien aux Pays-Bas qu\'en Belgique. Pensez à iDEAL, Bancontact, Apple Pay, Google Pay, Carte de crédit et bien d\'autres modes de paiement. Vous avez vous-même un contrôle total sur les modes de paiement que vous souhaitez proposer, activez-les ou désactivez-les simplement via le portail du fournisseur de paiement.',
    },
    10: {
      question: 'Comment recevons-nous les commandes dans le restaurant ?',
      answer: {
        1: 'Chez Bistroo, vous disposez de plusieurs options flexibles pour recevoir les commandes, adaptées à ce qui convient le mieux à votre restaurant. Les commandes arrivent par défaut directement dans votre boîte e-mail. Les notifications apparaissent également directement dans notre application Manager ou dans le portail Manager et vous pouvez activer les notifications SMS.',
        2: 'Vous voulez rendre cela encore plus facile ? Nous fournissons également du matériel comme des imprimantes de tickets et des appareils portables. De plus, dans de nombreux cas, nous pouvons connecter vos imprimantes existantes dans le restaurant, afin que vous puissiez commencer immédiatement sans équipement supplémentaire.',
        3: 'De plus, nous proposons souvent des connexions avec des systèmes de caisse, afin que les commandes soient intégrées de manière transparente dans votre flux de travail actuel. Cela vous fait gagner du temps et minimise les erreurs lors du traitement.',
        4: 'En résumé : avec Bistroo, vous choisissez vous-même comment vous recevez vos commandes, entièrement adapté à votre mode de gestion.',
      },
    },
    11: {
      question: 'Comment puis-je commencer ? Qu\'est-ce que cela nécessite ?',
      answer:
        'Vous pouvez commencer directement, rien n\'est nécessaire. Vous voulez vous lancer ? Créez simplement un compte gratuit sur notre site web, c\'est possible immédiatement. Si vous avez besoin de matériel spécifique, vous pouvez éventuellement l\'acheter chez nous, mais ce n\'est absolument pas obligatoire.',
    },
    12: {
      question: 'Demandez-vous des frais de démarrage ?',
      answer:
        'Chez nous, vous ne payez PAS de frais de démarrage. Uniquement pour le module QR, nous facturons le prix coûtant des autocollants QR.',
    },
    '15': {
      question: 'Qu\'est-ce qui rend Bistroo unique ?',
      answer:
        'Avec le logiciel de Bistroo, vous redevenez pleinement entrepreneur. La solution de Bistroo vous donne, en tant que vendeur, le contrôle sur votre boutique en ligne. Vous devenez véritablement propriétaire du processus, avec un contrôle total sur votre restaurant en ligne via le tableau de bord de Bistroo. Nous offrons tous les outils et le soutien dont vous avez besoin pour réussir votre restaurant en ligne. De plus, vous pouvez tout gérer en ligne via l\'auto-intégration de Bistroo. Bien sûr, l\'équipe de Bistroo se déplace également sur place si nécessaire.',
    },
    '16': {
      question: 'Pourquoi Bistroo est-il une meilleure alternative aux services de commande ?',
      answer:
        'Bistroo se distingue par son focus sur la rentabilité de l\'entrepreneur. Là où les services de commande traditionnels demandent des frais de volume jusqu\'à 30 % et gardent les données clients pour eux-mêmes, Bistroo est un fournisseur de logiciels avec un tarif fixe, bas et transparent. La différence la plus importante est que l\'entrepreneur chez Bistroo reste propriétaire des données clients, ce qui est essentiel pour le marketing et la fidélisation des clients.',
    },
    '17': {
      question: 'Quels produits Bistroo fournit-il ?',
      answer:
        'Bistroo fournit un ensemble e-commerce complet pour la restauration, tous gérables depuis le Manager, avec les produits suivants : BistrooWebshop : Une boutique en ligne pour les établissements de restauration pour les commandes à emporter et en livraison. BistrooPage : Site web + boutique en ligne pour les établissements de restauration via le logiciel de Bistroo. BistrooQR : Module QR permettant aux clients de commander et payer sur place. BistrooManager : Un système de gestion pour la gestion des menus et des paramètres. BistrooKiosk : Une borne de commande, permettant aux clients de faire leur choix sur place. BistrooPOS : Un système de caisse avec toutes les fonctionnalités pour les restaurants à emporter.',
    },
    '18': {
      question: 'Puis-je utiliser le logiciel de Bistroo si je suis également présent sur d\'autres services de commande ?',
      answer:
        'Oui, le logiciel de Bistroo fonctionne très bien à côté des services de commande externes. Nous vous aidons avec Bistroo à construire votre propre canal de commande direct via votre propre boutique en ligne, afin que vous soyez moins dépendant d\'un service de commande.',
    },
    '19': {
      question: 'Bistroo propose-t-il un service de livraison ?',
      answer:
        'Non, Bistroo ne propose pas lui-même de service de livraison comme les services de commande le font. Vous pouvez cependant utiliser vos propres livreurs et les gérer entièrement via le logiciel de Bistroo.',
    },
    '20': {
      question: 'Puis-je participer sans livreurs propres ?',
      answer:
        'Oui, vous pouvez démarrer avec le logiciel de Bistroo avec uniquement la vente à emporter ou la commande QR sur place.',
    },
    '21': {
      question: 'Quels résultats les restaurants obtiennent-ils en moyenne avec le logiciel de Bistroo ?',
      answer:
        'Nos études de cas de Bistroo montrent que les restaurants qui misent activement sur leur propre canal direct voient leur marge moyenne par commande augmenter de 15 % à 25 % par rapport aux services de commande ou aux commandes téléphoniques. De plus, nous constatons que la valeur des commandes pour les commandes Bistroo QR sur place est souvent 20 % plus élevée grâce à des fonctions d\'upsell intelligentes.',
    },
    '22': {
      question: 'Comment Bistroo aide-t-il à construire une clientèle fidèle ?',
      answer:
        'Chez Bistroo, vous êtes propriétaire des données. Vous pouvez envoyer un code promotionnel personnalisé aux clients qui n\'ont pas commandé depuis un certain temps. Les études de cas montrent que les restaurants utilisant le logiciel de Bistroo augmentent exponentiellement leurs visites répétées.',
    },
    '23': {
      question: 'Le logiciel de Bistroo peut-il gérer des volumes élevés pendant les heures de pointe ?',
      answer:
        'Certainement. Nous avons plusieurs cas de restaurants à emporter très fréquentés et de grandes terrasses qui font entièrement confiance au logiciel stable de Bistroo pendant les moments de pointe. La connexion directe au sein du système de Bistroo fait que la marge d\'erreur en cuisine est réduite à presque zéro. Les créneaux horaires intelligents assurent une bonne répartition des commandes ou des produits pendant la période de pointe, ce qui n\'est pas gérable via d\'autres systèmes ou par téléphone.',
    },
    '24': {
      question: 'Comment les entrepreneurs vivent-ils le passage au logiciel de Bistroo ?',
      answer:
        'Les entrepreneurs mentionnent souvent la "liberté" de Bistroo comparée aux services de commande comme le plus grand avantage. De plus, les restaurants constatent un énorme gain d\'efficacité par rapport aux commandes téléphoniques. La possibilité de modifier directement son menu ou de lancer une promotion en direct via le Bistroo Manager est également très appréciée.',
    },
    '26': {
      question:
        'Le logiciel de Bistroo est-il adapté aux chaînes de franchise ou aux entreprises avec plusieurs établissements ?',
      answer:
        'Oui, le Bistroo Manager est conçu pour l\'évolutivité. Depuis un compte central, les entrepreneurs peuvent gérer plusieurs établissements avec le logiciel de Bistroo. Notre construction de paiement partagé rend également le flux de paiements très fluide sans administration supplémentaire.',
    },
    '27': {
      question:
        'Bistroo propose-t-il également des solutions pour les \'dark kitchens\' ou les restaurants de livraison sans places assises ?',
      answer:
        'Absolument. Pour les dark kitchens, Bistroo propose un flux de travail rationalisé où les commandes arrivent directement sur l\'appareil portable, garantissant l\'indépendance vis-à-vis des services de commande externes grâce au logiciel de Bistroo.',
    },
    '28': {
      question: 'Avec quels systèmes de caisse le logiciel de Bistroo fonctionne-t-il ?',
      answer:
        'Le logiciel de Bistroo fonctionne avec Lightspeed, Winston Pos, Untill et Cashdesk. De plus, Bistroo fournit son propre système de caisse entièrement connecté à nos autres produits.',
    },
    '29': {
      question: 'Puis-je connecter ma comptabilité au système de Bistroo ?',
      answer:
        'Bistroo facilite une administration efficace en proposant des exports compatibles avec la plupart des logiciels de comptabilité. Grâce à la collaboration avec le fournisseur de paiement Stripe, les flux financiers sont rapportés de manière claire, ce qui accélère considérablement le traitement dans des logiciels comme Exact Online, Twinfield ou Yuki.',
    },
    '30': {
      question: 'Créez-vous un site web pour moi avec le logiciel de Bistroo ?',
      answer:
        'Oui, avec le produit BistrooPage, nous créons un site web complet pour vous, optimisé pour la conversion.',
    },
    '31': {
      question: 'J\'ai déjà un site web, puis-je quand même utiliser le logiciel de Bistroo ?',
      answer:
        'Oui, via le Bistroo Button, vous pouvez facilement connecter votre boutique Bistroo à votre site existant.',
    },
    '32': {
      question: 'J\'ai déjà un domaine, puis-je le connecter au logiciel de Bistroo ?',
      answer:
        'Oui, vous pouvez connecter votre domaine à un nouveau BistrooWebshop ou BistrooPage via un code de transfert que l\'équipe de Bistroo traitera pour vous.',
    },
    '33': {
      question: 'Comment le logiciel de Bistroo aide-t-il à résoudre les pénuries de personnel ?',
      answer:
        'Grâce à l\'utilisation du module Bistroo QR ou du BistrooKiosk, les clients peuvent commander de manière autonome. Cela réduit la pression sur le personnel, leur permettant d\'accomplir plus de travail avec l\'aide du logiciel de Bistroo.',
    },
    '34': {
      question: 'Comment Bistroo aide-t-il mon restaurant à mieux se positionner sur Google ?',
      answer:
        'Pour le produit BistrooPage, nous optimisons le site web techniquement (SEO). Comme le menu est affiché via Bistroo en texte HTML sur le site, Google peut indexer les plats.',
    },
    '35': {
      question: 'Puis-je essayer le logiciel de Bistroo gratuitement ?',
      answer:
        'Oui, toutes les formules de Bistroo sont disponibles en essai gratuit de 30 jours sans engagement et sans frais de démarrage !',
    },
    '36': {
      question: 'Quels sont les coûts du logiciel de Bistroo ?',
      answer:
        'Bistroo facture un montant mensuel fixe pour les abonnements, ou un module gratuit où vous ne payez qu\'un volume-fee par commande. Des coûts supplémentaires comme le matériel Bistroo sont facturés séparément. Pas de frais de démarrage ! Consultez le site web pour les prix spécifiques des produits.',
    },
    '37': {
      question: 'Puis-je résilier mensuellement chez Bistroo ?',
      answer: 'Nos abonnements sont toujours résiliables mensuellement.',
    },
    '38': {
      question: 'Ai-je droit à une remise si je paye un an à l\'avance chez Bistroo ?',
      answer:
        'Oui, si vous souhaitez payer un an à l\'avance, vous bénéficiez d\'une remise sur l\'abonnement chez Bistroo.',
    },
    '39': {
      question: 'Que faut-il pour commencer chez Bistroo ?',
      answer:
        'Vous pouvez commencer directement avec Bistroo, il ne faut rien d\'autre qu\'un compte sur le site web de Bistroo.',
    },
    '40': {
      question: 'De quoi ai-je besoin pour commencer avec le logiciel de Bistroo ?',
      answer:
        'Un appareil mobile, internet et les informations de votre restaurant sont suffisants pour commencer avec le logiciel de Bistroo.',
    },
    '41': {
      question: 'Comment dois-je m\'inscrire chez Bistroo ?',
      answer:
        'Vous pouvez vous inscrire via le site web de Bistroo ou via WhatsApp au 085-0250205. Créer un compte vous-même est possible sur merchant.bistroo.nl/register.',
    },
    '42': {
      question: 'Recevrai-je de l\'aide pour configurer mon compte Bistroo ?',
      answer: 'Oui, Bistroo propose une intégration personnalisée, aussi bien sur place qu\'à distance.',
    },
    '43': {
      question: 'Recevrai-je de l\'aide pour configurer mon menu en ligne dans le logiciel de Bistroo ?',
      answer:
        'Certainement ! L\'équipe de support de Bistroo aide à configurer votre menu et explique les modifications.',
    },
    '44': {
      question:
        'Que faire si je n\'ai pas de connaissances techniques, puis-je quand même utiliser le logiciel de Bistroo ?',
      answer:
        'Certainement ! Le logiciel de Bistroo est très facile à utiliser et nous vous aidons étape par étape.',
    },
    '45': {
      question: 'Quel matériel Bistroo fournit-il ?',
      answer:
        'Bistroo fournit un appareil portable de marque Sunmi, nous pouvons fournir des ordinateurs portables sur demande, nous fournissons des imprimantes de tickets USB/WiFi/Internet de marque Epson et une imprimante cloud de marque Sunmi. Nous fournissons également le matériel pour notre système de caisse, composé de : un terminal de paiement, un écran Sunmi, une imprimante cloud Sunmi et un tiroir-caisse. D\'autres matériels sont possibles sur demande, notre logiciel fonctionne sur tout. Pour nos bornes de commande, il existe différents modèles à l\'achat, qui vont d\'un modèle d\'entrée de gamme à des bornes double paroi très élaborées.',
    },
    '46': {
      question: 'Comment fonctionne l\'appareil portable de Bistroo ?',
      answer:
        'L\'appareil portable Sunmi de Bistroo est facile à utiliser pour la gestion des commandes et l\'impression de tickets avec le logiciel de Bistroo.',
    },
    '47': {
      question: 'Le logiciel de Bistroo fonctionne-t-il sur mon matériel existant ?',
      answer: 'Oui, le logiciel de Bistroo fonctionne sur tout appareil moderne disposant d\'un navigateur.',
    },
    '48': {
      question: 'Que dois-je faire si le logiciel de Bistroo n\'a pas de connexion internet ?',
      answer:
        'Utilisez un point d\'accès ou contactez le service client de Bistroo pour activer une carte SIM.',
    },
    '49': {
      question: 'Comment changer de réseau WiFi sur l\'appareil portable de Bistroo ?',
      answer:
        'Via les paramètres de l\'appareil Bistroo, vous pouvez facilement changer de réseau pour une connexion stable.',
    },
    '50': {
      question: 'Y a-t-il une carte SIM dans les appareils de Bistroo ?',
      answer:
        'Oui, les appareils de Bistroo contiennent une carte SIM qui peut être activée sur demande.',
    },
    '51': {
      question: 'L\'imprimante de l\'appareil portable ne fonctionne pas, que dois-je faire ?',
      answer:
        'Vérifiez le rouleau de ticket et la connexion, ou contactez le support de Bistroo.',
    },
    '52': {
      question: 'Comment remplacer le rouleau de ticket dans les appareils de Bistroo ?',
      answer:
        'Placez le rouleau avec le côté papier vers l\'avant dans l\'appareil Bistroo et testez une impression.',
    },
    '53': {
      question: 'Quelle taille de rouleau de ticket dois-je utiliser pour l\'appareil portable Bistroo ?',
      answer: 'Dans l\'appareil portable Sunmi de Bistroo, des rouleaux thermiques blancs 57x40x12 conviennent.',
    },
    '54': {
      question: 'Les rouleaux de ticket sont-ils livrés par Bistroo ?',
      answer:
        'Vous recevez standard un rouleau lors de la livraison de Bistroo. Des rouleaux supplémentaires peuvent être commandés chez Bistroo via 123 inkt, pour l\'appareil portable voici l\'URL : https://www.123inkt.nl/123inkt-kassarol-57x40x12-thermo-wit-5-stuks-40349EC-K-6023C-i52200-t4160297.html',
    },
    '55': {
      question: 'Bistroo remplace-t-il une imprimante défectueuse ?',
      answer:
        'Oui, à condition que le matériel de Bistroo ait été traité avec soin, nous le remplaçons dans des circonstances normales.',
    },
    '56': {
      question: 'Puis-je changer la langue sur l\'appareil portable ?',
      answer:
        'Oui, via les paramètres de l\'appareil. Cependant, le néerlandais ou l\'anglais est recommandé pour le logiciel de Bistroo.',
    },
    '57': {
      question: 'Où puis-je acheter les rouleaux de ticket pour l\'appareil portable de Bistroo ?',
      answer:
        'Via 123 inkt, via ce lien : https://www.123inkt.nl/123inkt-kassarol-57x40x12-thermo-wit-5-stuks-40349EC-K-6023C-i52200-t4160297.html',
    },
    '58': {
      question: 'Quelles bornes de commande Bistroo fournit-il ?',
      answer:
        'Nous proposons un modèle d\'entrée de gamme de Sunmi, mais nous pouvons également fournir des modèles sur mesure via nos partenaires, renseignez-vous pour les possibilités.',
    },
    '59': {
      question: 'J\'ai déjà du matériel, Bistroo peut-il l\'utiliser ?',
      answer:
        'En général oui, cependant nous devons obtenir une photo claire ou un numéro de modèle pour s\'assurer que notre logiciel peut bien fonctionner sur le matériel existant. En principe, notre règle est que nous pouvons fonctionner sur tout.',
    },
    '60': {
      question: 'Je veux fermer ma boutique sur Bistroo, comment faire ?',
      answer:
        'Mettez la boutique en ligne sur fermé dans le Bistroo Manager ou sur l\'appareil portable via le bouton coulissant. Pour fermer à distance, allez sur merchant.bistroo.nl.',
    },
    '61': {
      question: 'Comment ouvrir ma boutique sur Bistroo un jour supplémentaire ?',
      answer:
        'Ouvrez votre boutique via le curseur dans le Bistroo Manager ou configurez des horaires d\'ouverture exceptionnels sous \'horaires d\'ouverture & service\' si vous dérogez à vos horaires d\'ouverture standard.',
    },
    '62': {
      question: 'Dois-je rouvrir manuellement ma boutique sur Bistroo après une fermeture ?',
      answer:
        'Non. Une fois la date définie passée, le Bistroo Manager rebascule automatiquement vers votre planning hebdomadaire habituel.',
    },
    '63': {
      question: 'Puis-je planifier une période de congé complète dans le logiciel de Bistroo ?',
      answer:
        'Oui. Vous pouvez ajouter plusieurs lignes aux horaires d\'ouverture exceptionnels. Pour chaque jour de congé, vous ajoutez simplement une nouvelle ligne dans le Bistroo Manager.',
    },
    '64': {
      question: 'Comment modifier les délais de livraison dans le logiciel de Bistroo ?',
      answer:
        'Via Le Bistroo Manager > Paramètres de l\'établissement > \'horaires d\'ouverture & service\' > horaires d\'ouverture ou horaires exceptionnels par canal de distribution (à emporter, en livraison, sur place).',
    },
    '65': {
      question: 'Comment modifier mes prix chez Bistroo ?',
      answer:
        'Allez dans Produits Stock dans Le Bistroo Manager et cliquez sur le produit pour modifier le prix. Vous pouvez rechercher un produit en tapant dans le champ de recherche.',
    },
    '66': {
      question: 'Comment mettre à jour mon menu dans le logiciel de Bistroo ?',
      answer:
        'Modifiez les produits ou les catégories dans Le Bistroo Manager. Vous pouvez également créer un nouveau menu et le connecter au logiciel de Bistroo.',
    },
    '67': {
      question: 'Comment masquer temporairement des produits dans le logiciel de Bistroo ?',
      answer:
        'Désactivez temporairement le produit dans Le Bistroo Manager via le curseur à côté du produit. Ou cliquez sur menu dans l\'appareil portable de Bistroo et utilisez les curseurs par produit.',
    },
    '68': {
      question: 'Comment configurer des zones de livraison dans le logiciel de Bistroo ?',
      answer:
        'Allez dans \'horaires d\'ouverture & service\' > Livraison dans le Bistroo Manager et ajoutez ou modifiez des zones.',
    },
    '69': {
      question: 'Comment modifier les frais de livraison dans le logiciel de Bistroo ?',
      answer:
        'Via \'horaires d\'ouverture & service\' > Livraison dans Le Bistroo Manager, vous modifiez les frais de livraison par zone.',
    },
    '70': {
      question: 'Je veux livrer gratuitement via le logiciel de Bistroo, comment configurer cela ?',
      answer:
        'Mettez les frais de livraison à 0 pour la zone postale souhaitée dans les paramètres du Bistroo Manager.',
    },
    '71': {
      question: 'Puis-je proposer un menu déjeuner et dîner simultanément via le logiciel de Bistroo ?',
      answer:
        'Oui, vous pouvez créer plusieurs menus et les activer en fonction du temps via le logiciel de Bistroo.',
    },
    '72': {
      question: 'Puis-je proposer un menu uniquement pendant une certaine période ?',
      answer:
        'Oui, configurez via le Bistroo Manager quand le menu est disponible (par exemple uniquement pour le déjeuner ou le dîner).',
    },
    '73': {
      question: 'Puis-je proposer des produits pendant une certaine période ?',
      answer: 'Oui, via le Bistroo Manager, vous pouvez configurer des créneaux horaires par catégorie.',
    },
    '74': {
      question: 'Pourquoi \'sans boisson\' apparaît-il sur le ticket de Bistroo ?',
      answer:
        'Cela se produit lorsqu\'un produit a un menu déroulant dans lequel \'sans boisson\' est défini comme valeur par défaut dans le Bistroo Manager.',
    },
    '75': {
      question: 'Est-il nécessaire que par exemple \'sans boisson\' apparaisse sur le ticket de Bistroo ?',
      answer:
        'Non. Dans la plupart des cas, c\'est superflu. Vous pouvez configurer dans le Bistroo Manager que la première valeur est optionnelle, de sorte qu\'elle ne soit pas imprimée.',
    },
    '76': {
      question: 'Quand est-ce que je reçois mon versement de Bistroo ?',
      answer:
        'Les versements de Bistroo sont liés au calendrier du fournisseur de paiement Stripe. Le chiffre d\'affaires pour les commandes en ligne est standard calculé du jeudi au mercredi, et versé le lundi. Pour les paiements par carte, ce cycle est différent.',
    },
    '77': {
      question: 'Le versement de Bistroo est incorrect, comment est-ce possible ?',
      answer:
        'Vérifiez les factures de chiffre d\'affaires dans le Bistroo Manager. La retenue de Bistroo y est clairement indiquée.',
    },
    '78': {
      question: 'Comment vérifier mes versements dans le logiciel de Bistroo ?',
      answer:
        'Connectez-vous au Bistroo Manager via merchant.bistroo.nl > Factures. Vous voyez ici par transaction exactement ce qui a été versé par Bistroo.',
    },
    '79': {
      question: 'J\'ai reçu trop peu d\'argent de Bistroo, comment est-ce possible ?',
      answer:
        'Connectez-vous via le Bistroo Manager via merchant.bistroo.nl et regardez sous la rubrique factures et ouvrez la facture la plus récente. Vous verrez ici quelles transactions ont été incluses dans le versement. Notez que le cycle hebdomadaire standard de Stripe pour les paiements en ligne va du jeudi au mercredi, puis est versé le lundi. Vérifiez également si vous n\'avez pas effectué de remboursements pendant la période, cela est également clairement indiqué sur la facture de chiffre d\'affaires.',
    },
    '80': {
      question: 'Quels autres frais sont retenus par Bistroo ?',
      answer:
        'Les frais de transaction de Stripe, éventuellement les frais de terminal de la banque et le cas échéant les remboursements de matériel ou les corrections sont retenus sur le versement de Bistroo.',
    },
    '81': {
      question: 'Comment je reçois mes factures de Bistroo ?',
      answer:
        'Les factures se trouvent dans Le Bistroo Manager sous la rubrique Facturation. Vous les recevez également hebdomadairement de Bistroo à votre adresse e-mail.',
    },
    '82': {
      question: 'Comment télécharger mes factures de Bistroo ?',
      answer:
        'Allez dans Factures dans Le Bistroo Manager, choisissez la période et téléchargez en format PDF et Excel.',
    },
    '83': {
      question: 'Comment connaître mon chiffre d\'affaires journalier chez Bistroo ?',
      answer:
        'Vous trouvez votre chiffre d\'affaires journalier dans Le Bistroo Manager sur le tableau de bord ou via les rapports imprimés sur l\'appareil portable de Bistroo.',
    },
    '84': {
      question: 'Comment imprimer mon chiffre d\'affaires journalier via Bistroo ?',
      answer:
        'Via la section rapports dans Le Bistroo Manager, vous pouvez exporter et imprimer des rapports journaliers. Pour ce faire, cliquez sur l\'icône en haut à gauche de l\'écran dans l\'appareil portable de Bistroo.',
    },
    '85': {
      question: 'Que dois-je faire si j\'ai commis une erreur dans une commande client ?',
      answer:
        'En tant que restaurateur, vous pouvez ouvrir la commande et effectuer un remboursement (partiel) via l\'appareil portable de Bistroo ou Le Bistroo Manager.',
    },
    '86': {
      question: 'Comment annuler une commande dans le logiciel de Bistroo ?',
      answer:
        'Ouvrez la commande dans le Manager de Bistroo et choisissez rembourser. La commande est ainsi annulée.',
    },
    '87': {
      question: 'Comment résoudre une plainte avec le logiciel de Bistroo ?',
      answer:
        'Résolvez directement une plainte avec le consommateur et accordez éventuellement une remise ou un remboursement via le logiciel de Bistroo.',
    },
    '88': {
      question: 'Résolvez-vous les plaintes chez Bistroo ?',
      answer:
        'Bistroo accompagne en cas de plaintes, mais le restaurateur reste responsable du service, de la qualité de la nourriture et de la livraison.',
    },
    '90': {
      question: 'Que faire si un client n\'ouvre pas la porte lors d\'une livraison Bistroo ?',
      answer:
        'Essayez d\'abord de le contacter par téléphone. La commande via Bistroo est toujours payée à l\'avance, donc vous ne courez pas de risque financier direct.',
    },
    '91': {
      question: 'Je veux organiser un jour de promotion, le logiciel de Bistroo offre-t-il cette possibilité ?',
      answer:
        'Utilisez le module de remises dans le Bistroo Manager pour planifier une action de remise sur des jours spécifiques ou pour une période donnée.',
    },
    '92': {
      question: 'Bistroo m\'aide-t-il à faire de la publicité ?',
      answer:
        'Oui, Bistroo offre 1 000 flyers gratuits pour une première action. De plus, vous pouvez faire imprimer des flyers en marque blanche via Bistroo.',
    },
    '94': {
      question: 'Dans combien de temps modifiez-vous mon menu si je transmets une modification à Bistroo ?',
      answer:
        'Bistroo s\'efforce d\'apporter les modifications dans les 24 à 48 heures. En cas d\'urgence, Bistroo intervient plus rapidement.',
    },
    '95': {
      question: 'Comment contacter le service client de Bistroo ?',
      answer:
        "L'équipe de Bistroo est joignable par téléphone ou via WhatsApp au 085-0250205. Notre adresse e-mail est klantenservice{'@'}bistroo.nl.",
    },
    '96': {
      question:
        'Comment puis-je tester si mes modifications dans le logiciel de Bistroo ont réussi ?',
      answer:
        'Contactez le service client de Bistroo pour faire mettre temporairement l\'environnement en ligne en mode test.',
    },
  },
}
